// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"service-module--wrapper--3dxSZ","services":"service-module--services--BfosB","item":"service-module--item--3yFkH","shortDesc":"service-module--short-desc--rUQtV"};